export const genderIdentity = {
  MALE: { value: 1, label: 'male' },
  FEMALE: { value: 2, label: 'female' },
  TRANSGENDER: { value: 3, label: 'transgender' },
  NEUTRAL: { value: 4, label: 'neutral' },
  NOT_STATED: { value: 5, label: 'notStated' },
};
